import * as React from 'react';

import * as styles from './SearchBlockAdLayout.css';

export const SearchBlockAdLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
